import React from 'react';

import ClickableOpacity from '@hero/ui-kit/inputs/ClickableOpacity';

import * as Style from './style.module.scss';

export type SectionNavItem = {
    id: string; //  must match the id on the section element being scrolled to
    label: string;
};

type SectionNavProps = {
    items: SectionNavItem[];
    activeId?: string;
};

const SectionNav: React.FC<SectionNavProps> = ({ items, activeId }) => {
    const handleClick = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    return (
        <nav className={Style.nav}>
            {items.map((item) => (
                <ClickableOpacity
                    key={item.id}
                    onClick={() => handleClick(item.id)}
                    alt={`nav-${item.label}`}
                    className={`${Style.item} ${item.id === activeId ? Style.active : ''}`}
                >
                    {item.label}
                </ClickableOpacity>
            ))}
        </nav>
    );
};

export default SectionNav;
